// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__RRH2e","bg":"index_bg__ZiryJ","vs":"index_vs__O110B","title":"index_title__28Suj","desc":"index_desc__NHlCP","btn":"index_btn__JXBvK"};